<div class="box">
  <div class="columns">
    <div class="column">
      <span class="is-size-5">{{ 'dashboard.booking-search.title' | translate }}</span>
    </div>
  </div>

  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="columns">
      <div class="column is-3" *ngIf="!enabledReservationNumber">
        <app-input-field
          type="text"
          [form]="form"
          inputName="bookingCode"
          [uppercase]="true"
          [submitted]="submitted"
          label="{{ 'dashboard.booking-search.booking-code' | translate }}"
          placeholder="{{ 'dashboard.booking-search.booking-code' | translate }}"
          errorMessage="{{ 'dashboard.booking-search.submit-error' | translate }}"
        >
        </app-input-field>
      </div>
      <div class="column is-5 is-custom">
        <app-select-and-field
          [form]="form"
          inputNameTickets="ticketNumbers"
          inputNameType="searchType"
          id="pnrtkt"
          label="{{ 'dashboard.booking-search.search-criteria' | translate }}"
          [valueInput]="valueInput"
          [valuesSelect]="SEARCH_VALUES"
          [submitted]="submitted"
          [disabled]="disabledTickets"
          (valueChange)="trim($event)"
          (addControl)="addTicketToForm($event)"
          (deleteControl)="deleteTicket($event)"
          (tktChanged)="onTktChange($event)"
          [errorMessage]="'dashboard.booking-search.submit-error' | translate"
        ></app-select-and-field>
      </div>

      <div class="column is-5 is-custom">
        <app-input-select
          [form]="form"
          inputName="gds"
          [submitted]="submitted"
          [values]="gds"
          label="{{ 'dashboard.booking-search.gds' | translate }}"
          placeholder="{{ 'dashboard.booking-search.gds' | translate }}"
          errorMessage="{{ 'dashboard.booking-search.submit-error' | translate }}"
        >
        </app-input-select>
      </div>

      <div class="column pt-4 is-narrow booking-submit">
        <app-input-submit
          inputText="{{ 'dashboard.booking-search.submit' | translate }}"
          [isLeft]="true"
          [isFullWidth]="true"
          type="submit"
        ></app-input-submit>
      </div>
    </div>
  </form>
</div>
